import { Button } from "@/components/ui/buttons/button";

export const CampaignCard = () => {
  const isDisabled = true;
  return (
    <Button disabled={isDisabled} variant="gray" className="w-full">
      <div
        className={`rounded-xl p-[4px] shadow-xl w-full ${
          isDisabled ? "" : "group"
        } relative transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed animate-slide-left-fade opacity-0`}
        style={{ animationDelay: "500ms" }}
      >
        <div className="relative flex justify-between items-center gap-4 xs:gap-8 px-4 xs:px-8 rounded-md h-14 xs:h-24 overflow-hidden">
          {/* Background Graphic */}
          <div className="top-0 right-0 bottom-0 absolute w-1/2 skew-x-[-20deg] translate-x-4" />

          {/* Animated Shine */}
          <div
            className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full ${
              isDisabled ? "" : "group-hover:translate-x-full"
            } transition-transform duration-700 ease-in-out`}
          />

          <div className="z-10 relative flex flex-col items-start gap-1">
            <span className="drop-shadow-[3px_3px_0_rgba(0,0,0,0.8)] font-black text-white text-lg xs:text-3xl italic tracking-wider">
              CAMPAIGN
            </span>
            <div className="flex items-center gap-2">
              <span className="bg-[#5D4037]/80 px-2 py-0.5 rounded-sm font-bold text-[10px] text-white uppercase tracking-wider">
                STORY
              </span>
              <span className="font-bold text-pk-gray-4 text-xs xs:text-sm uppercase tracking-widest">
                Coming Soon
              </span>
            </div>
          </div>

          <span className="drop-shadow-lg text-2xl xs:text-5xl filter transform">
            📖
          </span>
        </div>
      </div>
    </Button>
  );
};
